import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../state/reducer';
import { closeModal } from '../state/modalSlice';
import { CloseIcon } from '../icons/close';
import { setupAvailableGroups } from '../state/functions';

const ModalManager = () => {
  const { isOpen, component: Component, context } = useSelector((state: RootState) => state.modal);
  const state = useSelector((state: RootState) => state)
  const dispatch = useDispatch();

  useEffect(() => {
    if (state.rights?.group_ids.length === 0) return;
    if (state.groupsToSelect.length === 0 && state.rights) {
      setupAvailableGroups ();
    }
  }, [state.rights])

  if (!isOpen || !Component) return null;

  const handleClose = () => dispatch(closeModal());

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    if (target.classList.contains('modal-overlay')) {
      handleClose();
    }
  };


  return (
    <div id="masterOverlay" className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <div className="aBtn closeModalIcon" onClick={handleClose}>
          <CloseIcon width={24} height={24} />
        </div>
        <Component {...context} closeModal={handleClose} />
      </div>
    </div>
  );
};

export default ModalManager;